<template>
  <v-card flat>
    <div v-if="selectedApplication && !selectedApplication.isCompanyApplication">
      <h1>{{ $t("application.welcome.title") }}</h1>

      <h4>{{ $t("application.instructor.welcome.boxTitle") }}</h4>
      <ul>
        <li>         <p class="pt-1">{{ $t("application.instructor.welcome.company-boxTitle") }}</p>
        </li>
      </ul>
      <p class="mt-n2">{{ $t("application.instructor.welcome.company-boxInfo") }}</p>

      <p v-if="hasTradeCertificates" v-html="$t('application.instructor.welcome.hasCertificates',{professions: currentUserTradeCertificatesProfessions})"></p>

      <p>{{ $t("application.instructor.welcome.company-boxInfo2") }}
        <span class="text-no-wrap">(<v-icon size="13">$sl-arrow-right</v-icon>)</span>
        {{ $t("application.instructor.welcome.company-boxInfo3") }}
      </p>

    </div>
    <MessageBox
      class="mt-3"
      :closable="true"
      v-if="
        selectedApplication &&
        selectedApplication.isCompanyApplication &&
        selectedApplication.instructor &&
        company
      "
    >
      <h6>{{ $t("labels.pre-filled-notification") }}</h6>
      <!-- <p>{{$t('application.instructor.welcome.company-prefilledBy')}} {{selectedApplication.instructor.employed | fullName}} {{$t('labels.on')}} {{company.name}}.</p> -->
      <p>
        {{ $t("application.instructor.welcome.company-prefilledBy") }} {{ createdBy }}.
      </p>
      <p class="py-1">
        {{ $t("application.instructor.welcome.call-company") }} {{ company.name }}.
      </p>
    </MessageBox>
    <!-- Go to next step -->
    <NextButton class="mt-6" @click="nextStep">{{ $t("tour.next") }}</NextButton>
    <!-- Go to previous step -->
    <BottomNav @clicked="$emit('goToStep', '-1')" />
  </v-card>
</template>

<script>
// Entryform for unknown user to become a apprentice
import API from "@/services/api.js";
import { mapActions, mapGetters } from "vuex";
import pick from "lodash/pick";
import get from "lodash/get";
import { RulesMixin } from "@/components/mixins";
import MessageBox from "@/components/Common/MessageBox.vue";
import NextButton from "@/components/Common/NextButton";
import BottomNav from "@/components/Application/BottomNav";

// @group Application-Apprentice
// ApplicationThanks component
export default {
  name: "ApplicationWelcome",

  mixins: [RulesMixin],
  components: {
    MessageBox,
    NextButton,
    BottomNav,
  },
  data: () => ({
    application: null,
    company: {},
    fields: ["id", "personalNumber", "country", "step", "mobilphone", "email"],
    valid: true,
  }),

  created() {
    this.initApplication();
  },

  watch: {
    /**
     * @vuese
     * Used to watch the selectedApplication and call initApplication and fetch professions
     * @arg called with no argument
     */
    selectedApplication: {
      handler: function () {
        this.initApplication();
      },
      deep: true,
    },
  },

  computed: {
    ...mapGetters("application", ["currentStep", "selectedApplication"]),
    ...mapGetters("currentuser", ["currentUser", 'hasTradeCertificates', "currentUserTradeCertificatesProfessions"]),
    createdBy() {
      return this.selectedApplication.issuedBy ? this.selectedApplication.issuedBy.fullName : (this.selectedApplication.instructor || {}).fullName;
    }
  },

  methods: {
    ...mapActions("application", ["setSelectedApplication", "updateSelectedApplication"]),
    /**
     * @vuese
     * Used to Initialize application with either selected or empty application
     */
    initApplication() {
      //console.log("sele::", this.selectedApplication)
      if (this.selectedApplication && this.selectedApplication.id) {
        this.application = pick(this.selectedApplication, this.fields);
      } else {
        this.application = Object.fromEntries(
          this.fields.map((f) => {
            return [f, null];
          })
        );

        //- And add defaults
        if (this.currentUser) {
          this.application.personalNumber = this.currentUser.personalNumber;
          this.application.email = this.currentUser.email;
          this.application.mobilephone = this.currentUser.mobilephone;
        }
      }
      this.application.country = "SE";
      this.application.step = this.currentStep;

      this.getCompanyById();
    },

    /**
     * @vuese
     * Used to watch the selectedApplication and fetch the company
     * @arg The argument is an integer value representing company id
     */
    getCompanyById() {
      if (!(this.selectedApplication && this.selectedApplication.companyId)) {
        return;
      }

      API.getCompany(this.selectedApplication.companyId)
        .then((response) => {
          this.company = response.data;
        })
        .catch((error) => {
          console.log("There was an fetching the company:", error);
        });
    },

    /**
     * @vuese
     * Used to go to the next step if form is valid and update the application with new criterias if application exist or create a new one if application don't exist
     * @arg The argument is an integer value representing company id if company exist
     */
    async nextStep() {
      if (this.application.id && this.application.id > 0) {
        API.updateApplication(this.application.id, { data: this.application })
          .then(() => {
            /**
             * @vuese
             * Used to update application in vuex store
             * @arg The params are current fields of the application
             */
            this.updateSelectedApplication(this.application);
            // Fire +1
            // @arg The argument is a integer representing (in which step to go)
            this.$emit("goToStep", "+1");
          })
          .catch((error) => {
            this.$events.fire("showError", this.$t("errors.save-failure"));
            console.log("There was an error:", error);
          });
      } else {
        //- This is the first step, so we should create application if there are none
        API.createApplication({
          data: this.application,
        })
          .then((response) => {
            /**
             * @vuese
             * Used to get the person application right after we created a new one
             */
            API.getApplicationPerson()
              .then((res) => {
                if (res.data) {
                  let applicationStart = { ...res.data, ...response.data };
                  /**
                   * @vuese
                   *  Used to set application to  store in vuex
                   */
                  this.setSelectedApplication(applicationStart);
                  // Fire +1
                  // @arg The argument is a integer representing (move one step forward)
                  this.$emit("goToStep", "+1");
                }
              })
              .catch((error) => {
                console.log("There was an error:", error);
              });
          })
          .catch((error) => {
            this.$events.fire("showError", this.$t("errors.save-failure"));
            console.log("There was an error:", error);
          });
      }
    },
  },
};
</script>

<style scoped></style>
